import React from 'react';
import styles from './TableContent.module.scss';
import { XPagination } from '@/components/xqxc_ui';
import { Table } from 'antd';
import PropTypes from 'prop-types';
import { tooltipStyle, tooltip, tooltipClick, cellWidth } from '@/components/TableCell';
import { isOC } from '@/assets/js/authType';

class TableContent extends React.Component {

    _columns = () => [
        {
            title: '手机号码',
            dataIndex: 'mobilePhone',
            key: 'mobilePhone',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: (text, record) => tooltipClick(text, () => {
                this.props.tableAction('detail', record);
            })
        },
        {
            title: '姓名',
            dataIndex: 'realName',
            key: 'realName',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '骑士等级',
            dataIndex: 'levelName',
            key: 'levelName',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '推荐来源',
            dataIndex: 'referrerRoleValue',
            key: 'referrerRoleValue',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '所属运营公司',
            dataIndex: 'operationName',
            key: 'operationName',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '小运力公司',
            dataIndex: 'smallTransportName',
            key: 'smallTransportName',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '关联区域数',
            dataIndex: 'zoneCount',
            key: 'zoneCount',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '骑士状态',
            dataIndex: 'stateValue',
            key: 'stateValue',
            width: cellWidth.small,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '工作状态',
            dataIndex: 'workStateValue',
            key: 'workStateValue',
            width: cellWidth.small,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '累计开工时长',
            dataIndex: 'workingHours',
            key: 'workingHours',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: (text) => {
                const result = this._timeConversion(text);
                return result;
            }
        },
        {
            title: '历史派单数量',
            dataIndex: 'sendOrderCount',
            key: 'sendOrderCount',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '接单数量',
            dataIndex: 'receiveOrderCount',
            key: 'receiveOrderCount',
            width: cellWidth.small,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '注册时间',
            dataIndex: 'registerTime',
            key: 'registerTime',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '操作',
            dataIndex: 'id',
            key: 'id',
            align: 'center',
            width: cellWidth.big,
            fixed: 'right',
            render: (id, record) => this._TableAction(record)
        },
    ];

    // 秒转时分，小于1分钟限时0分钟
    _timeConversion = (second = 0) => {
        const hour = Math.floor(second / 3600);
        const min = Math.floor((second - hour * 3600) / 60);
        const sec = Math.floor(second - hour * 3600 - min * 60);
        if (hour == 0 && min == 0) {
            return sec + '秒';
        } else if (hour > 0) {
            return hour + '小时' + min + '分钟';
        } else {
            return min + '分钟';
        }
    }

    _takeDataSource = (data) => {
        if (data && Array.isArray(data)) {
            return data;
        } else {
            return [];
        }
    }

    _TableAction = (record) => {
        const { tableAction } = this.props;
        // 当为禁用或拉黑时，显示为'启用'
        const disable = record.state == 'DISABLE' || record.state == 'BLACK' ? true : false;
        return (
            <div className={styles.action}>
                <div className={styles.item} onClick={() => tableAction('evaluate', record)}>骑士评价</div>
                {isOC() ? null : <div className={styles.item} onClick={() => tableAction('violation', record)}>骑士罚单</div>}
                <div className={styles.item} onClick={() => tableAction('available', record)}>{disable ? '启用' : '禁用'}</div>
                <div className={styles.item} onClick={() => tableAction('RelationshipAvailable', record,'change')}>{record.smallTransportId ? '修改运力公司':'绑定运力公司'}</div>
                <div className={styles.item} onClick={() => tableAction('RelationshipAvailable', record,'journal')}>日志</div>
            </div>
        );
    };

    render() {
        const { paginationChange } = this.props;
        const { pageNum, pageSize, resultTotal, dataList } = this.props.renderData;

        return (
            <div className={styles.tableContainer} style={{ height: '100%' }}>
                <Table
                    rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
                    rowKey={(r) => r.id}
                    columns={this._columns()}
                    dataSource={this._takeDataSource(dataList)}
                    pagination={false}
                    scroll={{ y: true }}
                />
                <XPagination
                    resultTotal={resultTotal}
                    pageSize={pageSize}
                    pageNum={pageNum}
                    onChange={paginationChange}
                />
            </div>
        );
    }
}

TableContent.propTypes = {
    renderData: PropTypes.object.isRequired, // 表格数据源
    tableAction: PropTypes.func.isRequired, // 表格操作
    paginationChange: PropTypes.func.isRequired, // 分页操作
};

export default TableContent;

